export default __webpack_public_path__ + "static/media/goodfic.c9af0761.png";